import React from 'react';

import Layout from '../components/Layout';
import PageTitle from '../components/PageTitle';
import Section from '../components/Section';

const NotFoundPage = () => (
  <Layout>
    <PageTitle title="Error 404" light />
    <Section light>The page you were looking for doesn't exists :(.</Section>
  </Layout>
);

export default NotFoundPage;
